import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';
import MediaManager from '@/api/MediaManager';

class URLButton extends VisualComponent {
    getType() { return "URLButton"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        const base = super.construct( context, prefab );
        
        // Switch English/German Button Name
        if(prefab.getURL().includes("raumtaenzer")){
            console.log("clicking on raumtaenzer");
            this.mesh = null;
            return base;
        }
        var userLang = navigator.language || navigator.userLanguage; 
        if(prefab.getURL().includes("Register")){
            if(userLang.includes("de")){
                this.mesh.material.emissiveTexture =  MediaManager.getMedia(283995).getTexture();
            }else{
                this.mesh.material.emissiveTexture =  MediaManager.getMedia(284345).getTexture();
            }
        }

        var url = prefab.getURL();

        // Switch English/German Brochures
        if(prefab.getURL().charAt(0) == "$"){
            url = url.substring(1);
            if(userLang.includes("de"))
                url = url.split(",")[0]
            else{
                if(url.includes(","))
                    url = url.split(",")[1] 
                else
                    url = url.split(",")[0]
            }            
        }

        this.mesh.actionManager = new BABYLON.ActionManager(context.scene);
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger,() => {
            if(url.includes("Register")){
                var event = new CustomEvent("openMeetingRegister",{detail:{type: url}});
                window.dispatchEvent(event);
            }else{
                if(prefab.getdisplayInternally() == "true"){
                    var event = new CustomEvent("openURL",{detail:{url: url,showURL: prefab.getdisplayUrl() == "true"}});
                    window.dispatchEvent(event);
                }else{
                    window.open(url, "_blank");                  
                }
            }
        }));


        // Hover-Over 
        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

        let highlight = null;
        if(prefab.getURL().charAt(0) == "$"){
            highlight = BABYLON.MeshBuilder.CreatePlane("", { 
                width: this.texture.getWidth() * prefab.getScale() * this.scaleFactor, 
                height: this.texture.getHeight() * prefab.getScale() *this.scaleFactor,
                sideOrientation: BABYLON.Mesh.DOUBLESIDE 
            }, context.scene);
            highlight.visibility = 0;
            highlight.material = new BABYLON.StandardMaterial("", context.scene);
            highlight.material.emissiveTexture = highlight.material.opacityTexture = new BABYLON.Texture("./flux/highlight.png", context.scene);
            highlight.material.disableLighting = true;  
            highlight.parent = base;
            highlight.isPickable = false;
        }
                
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger,() => {   
            BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,20, this.mesh.scaling, new BABYLON.Vector3.One(), 0, ease);  

            if(prefab.getURL().charAt(0) == "$")
                BABYLON.Animation.CreateAndStartAnimation("", highlight, "visibility", 30,10, highlight.visibility, 0, 0, ease);  
        }));

        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger,() => {         
            BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 30,20, this.mesh.scaling, new BABYLON.Vector3.One().scale(1.2), 0, ease);

            if(prefab.getURL().charAt(0) == "$")
                BABYLON.Animation.CreateAndStartAnimation("", highlight, "visibility", 30,10, highlight.visibility, 1, 0, ease);  
            
        }));

        return base;
    }
    

}

export default URLButton;
